const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCohostIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4648_662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
    fill: "url(#paint0_linear_4648_662)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5C17.5 14.366 14.366 17.5 10.5 17.5C6.63401 17.5 3.5 14.366 3.5 10.5C3.5 6.63401 6.63401 3.5 10.5 3.5C14.366 3.5 17.5 6.63401 17.5 10.5Z",
    fill: "#8B66F2",
    stroke: "black",
    style: {
      fill: "#8B66F2",
      fill: "color(display-p3 0.5451 0.4000 0.9490)",
      fillOpacity: 1,
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 6.146C10.4378 6.14556 10.3747 6.16312 10.3199 6.1967C10.2651 6.23028 10.2208 6.27854 10.192 6.336L9.01203 8.698L6.20803 9.129C6.14532 9.13884 6.08656 9.16584 6.03825 9.20701C5.98994 9.24817 5.95396 9.30191 5.93429 9.36225C5.91462 9.4226 5.91203 9.48722 5.92681 9.54894C5.94159 9.61067 5.97316 9.66711 6.01803 9.712L7.95703 11.652L7.52503 14.458C7.51544 14.5208 7.52343 14.5851 7.54813 14.6436C7.57282 14.7022 7.61325 14.7527 7.66493 14.7897C7.71661 14.8267 7.77752 14.8486 7.8409 14.8531C7.90429 14.8575 7.96767 14.8444 8.02403 14.815L10.5 13.523L12.977 14.815C13.0333 14.8445 13.0967 14.8578 13.1601 14.8533C13.2235 14.8489 13.2844 14.8269 13.336 14.7899C13.3877 14.7529 13.428 14.7023 13.4525 14.6437C13.4771 14.5851 13.4849 14.5208 13.475 14.458L13.043 11.651L14.983 9.711C15.0273 9.66593 15.0583 9.60958 15.0727 9.54809C15.0871 9.48661 15.0843 9.42235 15.0647 9.36232C15.0451 9.30229 15.0094 9.24879 14.9615 9.20765C14.9136 9.1665 14.8553 9.1393 14.793 9.129L11.989 8.698L10.808 6.336C10.7796 6.27915 10.7359 6.23129 10.6819 6.19775C10.6279 6.16421 10.5656 6.1463 10.502 6.146Z",
    fill: "#3A3A3A",
    style: {
      fill: "#3A3A3A",
      fill: "color(display-p3 0.2292 0.2292 0.2292)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4648_662",
    x1: 10.5,
    y1: 0,
    x2: 6.412,
    y2: 18.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1F46",
    style: {
      stopColor: "#1A1F46",
      stopColor: "color(display-p3 0.1020 0.1216 0.2745)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F46",
    style: {
      stopColor: "#1A1F46",
      stopColor: "color(display-p3 0.1020 0.1216 0.2745)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4648_662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohostIndicator);
export default __webpack_public_path__ + "static/media/cohost-indicator.bb77ae926e3b0bb1bacb5e9b23c9dd35b5836cdd2c1eb1a964438f0a36b76ed7.svg";
export { ForwardRef as ReactComponent };